import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from './shared.service';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslateModule } from '@ngx-translate/core';
import { UtilComponentsModule } from 'src/app/shared/util-components/util-components.module';
import { QrComponent } from './component/qr/qr.component';
import { ActionButtonComponent } from './component/action-button/action-button.component';
import { FriendlyNameComponent } from './component/friendly-name/friendly-name.component';
import { MfaIconComponent } from './component/mfa-icon/mfa-icon.component';
import { DynamicFormModule } from 'src/app/dynamic-form/dynamic-form.module';



@NgModule({
  declarations: [
    QrComponent,
    ActionButtonComponent,
    FriendlyNameComponent,
    MfaIconComponent
  ],
  imports: [
    CommonModule,
    QRCodeModule,
    UtilComponentsModule,
    TranslateModule,
    DynamicFormModule
  ],
  providers:[SharedService],
  exports:[QrComponent, MfaIconComponent, FriendlyNameComponent, ActionButtonComponent]
})
export class SharedModule { }
